"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _useFormContext = _interopRequireDefault(require("../../../../hooks/useFormContext"));
var _sprintf = _interopRequireDefault(require("../../../../../../utils/sprintf"));
var _dateFns = require("date-fns");
var _react = require("react");
var _server = require("react-dom/server");
var _uuid = require("uuid");
var _sv = _interopRequireDefault(require("../../../../sv.json"));
var FSTypes = _interopRequireWildcard(require("../../../../types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var validationName = "dateorder";
var DateOrder = function DateOrder(props) {
  var _a, _b, _c;
  var children = props.children,
    i18n = props.i18n,
    ignoreEqualDates = props.ignoreEqualDates,
    order = props.order,
    _d = props.type,
    type = _d === void 0 ? FSTypes.ValidationTypes.Error : _d,
    validateOnChange = props.validateOnChange;
  var uuid = (0, _react.useState)((0, _uuid.v4)())[0];
  var _e = (0, _useFormContext.default)(),
    addFormValidation = _e.addFormValidation,
    formI18n = _e.i18n,
    getFieldLabel = _e.getFieldLabel,
    removeFormValidation = _e.removeFormValidation;
  var validation = (0, _react.useCallback)(function (formData) {
    if (!order) {
      return [];
    }
    var dates = order.map(function (fieldName) {
      var _a, _b;
      return ((_a = formData === null || formData === void 0 ? void 0 : formData[fieldName]) === null || _a === void 0 ? void 0 : _a.value) ? new Date(String((_b = formData === null || formData === void 0 ? void 0 : formData[fieldName]) === null || _b === void 0 ? void 0 : _b.value)) : undefined;
    }).filter(Boolean);
    // validate only if all dates are filled
    if (dates.length !== order.length) {
      return [];
    }
    var valid = dates.reduce(function (valid, date, index) {
      if (index === 0) {
        return valid;
      }
      return valid && (ignoreEqualDates && !(0, _dateFns.isBefore)(date, dates[index - 1]) || (0, _dateFns.isAfter)(date, dates[index - 1]));
    }, true);
    if (valid) {
      return [];
    }
    return order.map(function (fieldName) {
      var _a, _b, _c;
      return {
        fieldName: fieldName,
        type: type,
        involvedFieldNames: order,
        text: children !== undefined ? (0, _server.renderToString)((0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: children
        })) : (0, _sprintf.default)((i18n === null || i18n === void 0 ? void 0 : i18n.text) || ((_c = (_b = (_a = formI18n === null || formI18n === void 0 ? void 0 : formI18n.validations) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.dateOrder) === null || _c === void 0 ? void 0 : _c.text) || _sv.default.validation.form.dateOrder.text, {
          fieldLabels: order.map(function (fieldName) {
            return getFieldLabel(fieldName);
          }).join(", ")
        })
      };
    });
  }, [children, (_c = (_b = (_a = formI18n === null || formI18n === void 0 ? void 0 : formI18n.validations) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.dateOrder) === null || _c === void 0 ? void 0 : _c.text, getFieldLabel, i18n === null || i18n === void 0 ? void 0 : i18n.text, ignoreEqualDates, order, type]);
  (0, _react.useEffect)(function () {
    addFormValidation("".concat(validationName, "_").concat(uuid), order || [], validation, validateOnChange);
    return function () {
      removeFormValidation("".concat(validationName, "_").concat(uuid));
    };
  }, [addFormValidation, order, removeFormValidation, uuid, validateOnChange, validation]);
  return null;
};
var _default = DateOrder;
exports.default = _default;